import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

/**
 * 새 디자인 화면 아래쪽 사업자 정보 (2026-10). 전자결제(토스페이먼츠) 심사·전자상거래법상 표시 사항.
 * 통신판매업 신고번호·전화는 2026-10-04 사장님 확인(유효).
 */
const BizInfo: React.FC = () => (
  <Box>
    <p>
      상호 에스비(SB) · 대표 한선일 · 사업자등록번호 429-40-00717
      <br />
      통신판매업 신고 제 2020-의정부호원-0388 호
      <br />
      경기도 의정부시 신흥로 81, 101동 1104호(호원동, 쌍용스윗닷홈아파트)
      <br />
      전화 070-7604-7780 · hansunil@gmail.com
    </p>
    <nav>
      <Link to="/pricing">구독 안내</Link>
      <Link to="/policy/service">이용약관</Link>
      <Link to="/policy/privacy">개인정보처리방침</Link>
      <Link to="/support">문의하기</Link>
    </nav>
  </Box>
);

export default BizInfo;

const Box = styled.footer`
  margin-top: 8px;
  padding: 20px 0 8px;
  border-top: 1px solid #23262e;
  color: #7c8392;
  font-size: 12px;
  line-height: 1.7;
  word-break: keep-all;
  & > p {
    margin: 0 0 8px;
  }
  & > nav {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }
  & a {
    color: #a3a9b5;
    text-decoration: none;
  }
`;
